export const environment = {
  production: false,
  apiDomain: 'argo.ml3ds-rt-cloud.com',
  panoResourcesBaseUrl: 'https://panoresourcesrt-a8aca9b9g2eedbfw.a03.azurefd.net/files',
  buildNumber: '163',
  isOffline: false
};
